import React, {
  useContext,
  useState,
  createContext,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import io from "socket.io-client";
import { useUserToken } from "./UserTokenContext";
import { useCustomer } from "./CustomerContext";
import { useCreateTab } from "./CreateTabContext";
import DashboardService from "../services/DashboardService";
import { generalNotificationSound } from "../utils/audioManager";
import { Phone } from "@phosphor-icons/react";
import { API_BASE_URL } from "../config/config";
import moment from "moment";
moment.locale("tr");

const SignalRContext = createContext();

export const SignalRProvider = ({ children }) => {
  const {
    account,
    callerID,
    userToken,
    setNotifications,
    userName,
    userID,
    email,
    userPassword,
    userLang,
    isMuted,
  } = useUserToken();
  const socketRef = useRef(null);
  const [authorization, setAuthorization] = useState(false);
  const [activityBoardData, setActivityBoardData] = useState([]);
  const [activeCallData, setActiveCallData] = useState([]);
  const [extensionStateData, setExtensionStateData] = useState([]);
  const [outgoingCallData, setOutgoingCallData] = useState(null);
  const [callType, setCallType] = useState(null);
  const [deferredPoolData, setDeferredPoolData] = useState(null);
  const [showDeferredModal, setShowDeferredModal] = useState(false);
  // console.log("outgoingCallData -->", outgoingCallData);
  // console.log("callType -->", callType);

  const callTypeRef = useRef(null);

  const handleCallRef = useRef(null);

  const registerHandleCall = (func) => {
    handleCallRef.current = func;
  };

  const { addNewTab } = useCreateTab();
  const addNewTabRef = useRef(addNewTab);

  const generalNotificationSoundRef = useRef(generalNotificationSound);

  const isMutedRef = useRef(isMuted);
  useEffect(() => {
    isMutedRef.current = isMuted;
  }, [isMuted]);


  // addNewTabRef'i her render'da güncelleyerek stale closure'ı önlüyoruz
  useEffect(() => {
    addNewTabRef.current = addNewTab;
  }, [addNewTab]);

  const { setDidUrl } = useCustomer();

  useEffect(() => {
    callTypeRef.current = callType;
  }, [callType]);

  // -------------------------------------------------

  useEffect(() => {
    if (userToken === "") return;

    const socket = io(`${API_BASE_URL}:5006/`, {
      transports: ["websocket"],
    });

    socketRef.current = socket;

    const handleAuthSuccess = () => {
      socket.emit("GET_ACTIVE_CALLS");
      socket.emit("GET_EXTENSION_STATE");
      socket.emit("GET_ACTIVITYBOARD");
      setAuthorization(true);
    };

    socket.on("connect", () => {
      socket.emit("AUTH", {
        email: email,
        password: userPassword,
        accountcode: account.acc_accountcode,
        extension: callerID,
      });
    });

    socket.on("AUTH_SUCCESS", handleAuthSuccess);

    return () => {
      socket.off("AUTH_SUCCESS", handleAuthSuccess);
      socket.disconnect();
      setAuthorization(false);
    };
  }, [account, userToken]);

  useEffect(() => {
    // if (!autharization) return;

    socketRef?.current?.on("ACTIVE_CALLS", (data) => {
      setActiveCallData(data);
      // console.log("ACTIVE_CALLS data -->", data);
    });

    socketRef?.current?.on("EXTENSION_STATE", (data) => {
      setExtensionStateData(data);
      // console.log("EXTENSION_STATE data -->", data);
    });

    socketRef?.current?.on("ACTIVITYBOARD", (data) => {
      setActivityBoardData(data);
      // console.log("ACTIVITYBOARD data -->", data);
    });

    socketRef?.current?.on("DEFERRED_CALL_WARNING", (data) => {
      let messageName = data?.customerName;
      let messageDate = data?.scheduledAt;

      if (data?.type !== "customer-card") {
        messageName = data?.Response?.Numberpooldata?.numberpool_name;
        messageDate = data?.Response?.Numberpooldata?.scheduledAt || data?.scheduledAt;
      }

      const formattedDate = moment(messageDate).format(
        "DD.MM.YYYY HH:mm",
      );

      const notificationMessage = `Ertelenmiş bir görüşmeniz var (${messageName} ${formattedDate})`;


      generalNotificationSoundRef.current.currentTime = 0;
      if (!isMutedRef.current) {
        generalNotificationSoundRef.current.volume = 0.5;
        generalNotificationSoundRef.current
          .play()
          .catch((err) => console.warn("Ses çalma hatası:", err));
      }

      setNotifications((prev) => [
        {
          type: "call-deferred",
          message: notificationMessage,
          icon: <Phone size={32} color="#ff5b05" />,
          onPress: () => {
            if (data?.Response?.Numberpooldata?.type === "pool") {
              // handleCallRef.current?.handleCall(data?.customerNumber);

              //burdan bir tetikletme ile dataManagementAdd sayfası açılacak içine data geçilecek
              setDeferredPoolData(data.Response);
              setShowDeferredModal(true);
              handleCallRef.current?.setCall(true);

            } else if (data.type === "customer-card") {
              // Ref üzerinden çağırarak en güncel state'e sahip addNewTab'i kullanıyoruz
              addNewTabRef.current(
                data?.customerName,
                "Crm/Customer/CustomerEdit",
                true,
                data?.customerId,
              );
            }
          },
        },
        ...prev,
      ]);
      DashboardService.generalLog({
        token: userToken,
        accountcode: account?.acc_accountcode,
        userid: userID,
        usertitle: userName,
        type: "call-deferred",
        message: notificationMessage,
      })
        .then((res) => {
          // console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    });

    socketRef?.current?.on("OUTBOUND_CALL_DATA", (data) => {
      setOutgoingCallData(data);
      // console.log("OUTBOUND_CALL_DATA data -->", data);
      const customerNumber = data?.call?.customerNumber;
      const newTabUrl = data?.call?.didUrl;

      if (
        newTabUrl !== null &&
        data?.call?.didUrlTarget === "0" &&
        callTypeRef.current === "customer_card"
      ) {
        setDidUrl((prev) => ({
          ...prev,
          [customerNumber]: newTabUrl,
        }));
      } else if (newTabUrl !== null && data?.call?.didUrlTarget === "1") {
        window.open(newTabUrl, "_blank", "noopener,noreferrer");
      }
    });

    return () => {
      socketRef?.current?.off("ACTIVE_CALLS");
      socketRef?.current?.off("EXTENSION_STATE");
      socketRef?.current?.off("ACTIVITYBOARD");
      socketRef?.current?.off("DEFERRED_CALL_WARNING");
      socketRef?.current?.off("OUTBOUND_CALL_DATA");
      // socketRef.current.off("CALLSTATE");
    };
  }, [authorization]);

  const value = {
    activeCallData,
    extensionStateData,
    activityBoardData,
    socketRef,
    outgoingCallData,
    setOutgoingCallData,
    setCallType,
    registerHandleCall,
    deferredPoolData,
    setDeferredPoolData,
    showDeferredModal,
    setShowDeferredModal,
  };

  return (
    <SignalRContext.Provider value={value}>{children}</SignalRContext.Provider>
  );
};

export const useSignalR = () => useContext(SignalRContext);
